import React from 'react';
import { Object } from 'core-js';
import propTypes from 'prop-types';

const getStyle = (config) => {
  const defaultStyle = {
    position: 'relative',
    top: '0px',
    left: '0px',
  };
  if (config.style) {
    return Object.assign(defaultStyle, config.style);
  }
  return defaultStyle;
};

const renderAirlineLogo = (config) => {
  let returnedLogo = '';
  const isDark = config.dark;
  switch (config.airline) {
    case ('jetsuite'):
      returnedLogo = require(`./images/logos/jetsuite${isDark ? '-dark' : ''}.png`);
      break;
    case ('surfair'):
      returnedLogo = require(`./images/logos/surfair${isDark ? '-dark' : ''}.png`);
      break;
    case ('fiji'):
      returnedLogo = require('./images/logos/fiji.png');
      break;
    case ('united'):
      returnedLogo = require(`./images/logos/united${isDark ? '-dark' : ''}.png`);
      break;
    case ('delta'):
      returnedLogo = require('./images/logos/delta.png');
      break;
    case ('american'):
      returnedLogo = require('./images/logos/american.png');
      break;
    case ('airCanada'):
      returnedLogo = require('./images/logos/airCanada.png')
      break;
    case ('virgin'):
      returnedLogo = require(`./images/logos/virgin${isDark ? '-dark' : ''}.png`);
      break;
    default:
      // returnedLogo = require('./images/logos/logo-7.png');
      break;
  }
  return (
    <div>
      <img style={getStyle(config)} src={returnedLogo} alt="" />
    </div>
  );
};

const AirlineLogo = props => renderAirlineLogo(props);

AirlineLogo.propTypes = {
  airline: propTypes.string.isRequired,
};

AirlineLogo.defaultProps = {
  dark: false,
};

export default AirlineLogo;



// WEBPACK FOOTER //
// ./src/components/AirlineLogo/AirlineLogo.jsx